<template>
  <div class="padding text-center">
    <h2
      class="text-left slide-title-style mt-0"
      :inner-html.prop="$store.state.slide.title | sanitize(true)"
      v-if="$store.state.slide.title && $store.state.slide.type != 'document'"
    />
    <div
      class="audio-control-slide"
      v-if="$store.state.slide.audioLink && $store.state.slide.audioPlayOnAudience && $store.state.slide.id"
    >
      <AudioControl />
    </div>
    <div class="img-slide" v-if="$store.state.slide.image">
      <img :src="$store.state.slide.image.large" alt="">
    </div>
    <div
      class="img-caption text-break"
      v-if="$store.state.slide.subheading && $store.state.slide.type != 'document'"
      :inner-html.prop="$store.state.slide.subheading | sanitize(true)"
    />
    <div class="no-data" v-if="!$store.state.slide.subheading && !$store.state.slide.image">
      <p class="mb-3">
        {{ $t("blankSlide") }}
      </p>
    </div>

    <!-- Reactions -->
    <Reaction />
  </div>
</template>
<script>
import Reaction from '@/components/Reaction.vue'
import AudioControl from '@/components/AudioControl.vue'

export default {
  components: {
    Reaction,
    AudioControl,
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.audio-control-slide {
  margin-bottom: 16px;
}
.img-slide {
  img {
    max-width: 100%;
    max-height: 400px;
  }
}
.img-caption {
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.audio-control-slide {
  text-align: center !important;
}
</style>
